export default [
    {
        title: '序号',
        type: 'number',
        dataIndex: 'id',
        key: 'id',
        width: '10%',
        sorter: (a, b) => a.id - b.id,
        // editable: true,
    },
    {
        title: '地址',
        type: 'string',
        dataIndex: 'ip',
        key: 'ip',
        sorter: (a, b) => Number(a.ip.split('.')[0]) - Number(b.ip.split('.')[0]),
        editable: true,
    },
    {
        title: '端口',
        type: 'string',
        dataIndex: 'port',
        key: 'port',
        sorter: (a, b) => Number(a.port) - Number(b.port),
        editable: true,
    },
    {
        title: '用户名',
        type: 'string',
        dataIndex: 'user',
        key: 'user',
        editable: true,
    },
    {
        title: '密码',
        type: 'string',
        dataIndex: 'password',
        key: 'password',
        editable: true,
    }
];